import React from 'react';
import { ActivationAttribute } from '@amzn/storm-ui-page-header';
import { chromeComponents } from 'src/constants';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { Toggle } from '../types';

export const AttributesToggle: React.VFC<Toggle> = ({
  id,
  isDisabled,
  isActive,
  toolTip,
  tooltipPosition,
  eventHandler,
  ariaLabel,
}) => {
  return (
    <ActivationAttribute
      id={id}
      active={isActive}
      disabled={isDisabled}
      onChange={(...args) =>
        eventHandler(args.length === 2 ? args[1] : args[0])
      }
      helptipText={toolTip}
      helptipTextPosition={tooltipPosition}
      data-ccx-e2e-id={`aac-attribute-${id}`}
      aria-label={ariaLabel}
      {...getTaktAttributes(id, chromeComponents.HEADER)}
    />
  );
};
